<nav class="p-4">
  <mat-nav-list class="!p-0 overflow-x-hidden overflow-y-auto pb-24">
    @for (item of sidebarMenuItems(); track item.title) {
      <ng-container *appHasRole="item.roles">
        <mat-list-item
          (click)="toggleSubmenu(item, $event)"
          [routerLink]="item.link"
          [routerLinkActive]="item.submenu ? '' : '!bg-primary-light'"
          [ngClass]="{ '!bg-primary-light': isParentActive(item) }"
          class="mb-1">

          <div class="flex justify-between items-center w-full">
            <div
              class="flex"
              [ngClass]="{
                '!text-primary font-medium': isParentActive(item) || isLinkActive(item.link),
              }">
              <mat-icon>{{ item.icon }}</mat-icon>
              <span class="pl-2">{{ item.title }}</span>
            </div>

            @if (item.submenu?.length) {
              <div class="flex items-center pl-4">
                <mat-icon [ngClass]="{ '!text-primary': isParentActive(item) }">{{
                  activeSubmenuTitle === item.title ? 'expand_less' : 'expand_more'
                }}</mat-icon>
              </div>
            }
          </div>
        </mat-list-item>

        @if ((activeSubmenuTitle === item.title && isParentActive(item)) || activeSubmenuTitle === item.title) {
          <div class="pl-8">
            @for (subItem of item.submenu; track subItem.title) {
              <ng-container *appHasRole="subItem.roles">
                <a
                  mat-list-item
                  [routerLink]="subItem.link"
                  routerLinkActive="!bg-primary-light !text-primary font-medium"
                  class="pl-8 mb-1">
                  <span>{{ subItem.title }}</span>
                </a>
              </ng-container>
            }
          </div>
        }
      </ng-container>
    }
  </mat-nav-list>
</nav>
